import { Images } from "../../../Images";
import MineDamageLogic from "../../../logic/MineDamageLogic";
import NumberFormatter from "../../../util/NumberFormatter";
import ValueCalculator from "../../../util/ValueCalculator";
import MinedUpgrade from "./MinedUpgrade";
import MinedUpgradeCreator from "./MinedUpgradeCreator";
import { UpgadeCreatorIds } from "./UpgradeCreatorIds";

export default class MinedDamageBonusUpgradeCreator extends MinedUpgradeCreator {
    /**
     * @param {Values} values 
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(values, mineDamageLogic) {
        super(UpgadeCreatorIds.mineDamage, values, null);

        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;
    }

    /**
     * @abstract
     * @param {GridTile} tile
     * @returns {Upgrade}
     */
    createMinedUpgrade(tile) {
        // This is not a percent, it is a multiplier that starts at 0, not 1.
        // (The 1 will be added on later in MineDamageLogic.calculateTotalMineDamagePerTurn())
        const value = ValueCalculator.calculateMinedDamageUpgradeValue(tile);

        const minedDamageBonus = this.values.skillMinedDamageBonus.getValue();
        if (minedDamageBonus > 0) {
            value.addNumber(minedDamageBonus);
        }

        return this.createInternal(value);
    }

    /**
     * @override
     * @param {BigNum} valueDelta
     * @returns {Upgrade}
     */
    createFreeValueUpgradeFromSave(valueDelta) {
        return this.createInternal(valueDelta);
    }

    /**
     * @private
     * @param {BigNum} valueDelta
     * @returns {Upgrade}
     */
    createInternal(valueDelta) {
        const title = this.createTitle(valueDelta);
        return new MinedUpgrade(this, title, Images.pick, valueDelta, this.values.minedDamageBonusMultiplier, this.mineDamageLogic);
    }

    /**
     * @override
     * @param {Upgrade} upgrade1
     * @param {Upgrade} upgrade2
     */
    combineUpgradesInternal(upgrade1, upgrade2) {
        // All we need to do is to add the valueDelta values.
        upgrade1.valueDelta.add(upgrade2.valueDelta);
        upgrade1.title = this.createTitle(upgrade1.valueDelta);
   }

    /**
     * @private
     * @param {BigNum} valueDelta 
     * @returns {string}
     */
    createTitle(valueDelta) {
        return 'Multiplier: +' + NumberFormatter.formatBigNum(valueDelta);
    }
}